import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../TheBorder";
import {gsap} from "gsap";
import {TheBorderStatics} from "../TheBorderStatics";
import {TheBorderXBombSymbol} from "../reels/TheBorderXBombSymbol";
import {ISymbol} from "../../core/reel/ReelInterfaces";
import {TheBorderGameMode} from "../server/TheBorderGameMode";
import {TheBorderSymbol} from "../reels/TheBorderSymbol";

/**
 * Created by Jerker Nord on 2022-04-12.
 */

export class TheBorderXBombView extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "TheBorderXBombView";
        this.init();
    }

    public getXBombExplodeAnimation(xBombPositions: ISymbol[], allNoWinPositions: boolean[][]): gsap.core.Timeline {
        let mainTL: gsap.core.Timeline = gsap.timeline(),
            subMainTL: gsap.core.Timeline[] = [],
            explodePosMap: Map<number, number[]> = new Map<number, number[]>(),
            sym: TheBorderSymbol;

        TheBorder.model.explodePositions.forEach((reels: boolean[], reelId: number) => {
            reels.forEach((shouldExplode: boolean, rowId: number) => {
                if (!explodePosMap.has(reelId)) {
                    explodePosMap.set(reelId, []);
                }
                shouldExplode = !TheBorder.model.allWinPositions[reelId][rowId] && shouldExplode;
                if (shouldExplode && explodePosMap.get(reelId)?.indexOf(rowId) === -1) {
                    explodePosMap.get(reelId)?.push(rowId);
                }
            });
        });

        for (let i: number = 0; i < xBombPositions.length; i++) {
            let xBombTL: gsap.core.Timeline = gsap.timeline();
            const xBombSym: TheBorderXBombSymbol = (<TheBorderXBombSymbol>xBombPositions[i]),
                xBombSwooshX: number = (xBombSym.x + (TheBorderStatics.reelPositions[xBombSym.reelId].x)),
                xBombSwooshY: number = (xBombSym.y - (xBombSym.sizeMultiplier === 0.5 ? 25 : 0)),
                canPlaySound: boolean = (i === (xBombPositions.length - 1));

            // #294
            if (!explodePosMap.has(xBombSym.reelId)) {
                explodePosMap.set(xBombSym.reelId, []);
            }
            explodePosMap.get(xBombSym.reelId)?.push(xBombSym.reelPosition - 1);

            xBombTL.add(xBombSym.playXBombExplosionAnimation(i).restart());
            xBombTL.add([
                () => {
                    // #161
                    if (TheBorder.model.gameData.mode.indexOf(TheBorderGameMode.SUPER_FREESPIN) > -1) {
                        for (let i: number = 0; i < allNoWinPositions.length; i++) {
                            for (let j: number = 0; j < allNoWinPositions[i].length; j++) {
                                sym = (TheBorder.allReelsView.getSymbolAtPosition(i, j) as TheBorderSymbol);
                                if (!TheBorder.model.allWinPositions[i][j] && sym && sym.splitLevel > 1) { //#257
                                    if (!allNoWinPositions[i][j] || TheBorder.SYMBOLS_NOT_EXPLODING.indexOf(sym.symbolName) > -1) {
                                        TheBorder.swooshAnimation.playSwoosh(xBombSwooshX, xBombSwooshY, (sym.x + (TheBorderStatics.reelPositions[sym.reelId].x) + sym.splitLevelContainer.x / 2), (sym.y + sym.splitLevelContainer.y), false);
                                    }
                                }
                            }
                        }
                    }
                },
                TheBorder.swooshAnimation.playSwoosh(xBombSwooshX, xBombSwooshY, 610, -84, canPlaySound)
            ], 0.6);
            let addToMultiplier: number = xBombSym.splitLevel;
            xBombTL.add(() => {
                TheBorder.winMultiplierView.addToWinMultiplier(addToMultiplier, canPlaySound);
                // #161
                //allNoWinPositions is all explode positions
                if (TheBorder.model.gameData.mode.indexOf(TheBorderGameMode.SUPER_FREESPIN) > -1) {
                    for (let i: number = 0; i < allNoWinPositions.length; i++) {
                        for (let j: number = 0; j < allNoWinPositions[i].length; j++) {
                            sym = (TheBorder.allReelsView.getSymbolAtPosition(i, j) as TheBorderSymbol);
                            if (!TheBorder.model.allWinPositions[i][j] && sym && sym.splitLevel > 1) { //#257
                                if (!allNoWinPositions[i][j] || TheBorder.SYMBOLS_NOT_EXPLODING.indexOf(sym.symbolName) > -1) {
                                    sym.splitLevel += addToMultiplier;
                                }
                            }
                        }
                    }
                }
            });
            subMainTL.push(xBombTL);
        }

        if (xBombPositions.length) {
            mainTL.add(subMainTL);
            mainTL.add(() => {
                explodePosMap.forEach((currentRowArr: number[], currentReelId: number) => {
                    currentRowArr.forEach((currentRowId: number) => {
                        let symbol: TheBorderXBombSymbol = <TheBorderXBombSymbol>TheBorder.allReelsView.mainReelModels[currentReelId].getSymbol(currentRowId);

                        //Symbol might have been removed by win or another XBomb
                        if (symbol && TheBorder.SYMBOLS_NOT_EXPLODING.indexOf(symbol.symbolName) === -1 && !symbol.isRemoved) {
                            symbol.isRemoved = true;
                            TheBorder.allReelsView.mainReelModels[currentReelId].reelView.removeAvalancheSymbol(symbol);
                        }
                    });
                });
            }, 0.6);

            // #324
            mainTL.add(() => {
                TheBorder.xBombSymbols.xBombSymbols.forEach((sym: TheBorderXBombSymbol) => {
                    if (sym.reelId > -1) {
                        TheBorder.allReelsView.mainReelModels[sym.reelId].reelView.removeBombSymbol(sym);
                        sym.isRemoved = true;
                    }
                });
            });
        }

        return mainTL;
    }

    private init() {
        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }
}